import { formatDateTime, trim } from '@/support/String';
import { Token } from '@/support/Token';
import axios from 'axios';
import ErrorHandler from '@/support/ErrorHandler';
let API = '';
const Qs = require('qs');
export default (method, url, payload, hasPdf = false) => {
    const headers = {
        'Accept': hasPdf ? 'application/pdf' : 'application/json',
        'Content-type': 'application/json',
    };
    API = `${identifyHostname()}/v3`;
    if (isLocal()) {
        headers['X-Application'] = identifyApplication();
    }
    if (Token.get()) {
        headers.Authorization = `Bearer ${Token.get()}`;
    }
    const client = axios.create({
        baseURL: API,
        headers,
        paramsSerializer: (params) => {
            return Qs.stringify(params, { arrayFormat: 'brackets' });
        },
    });
    let hasFile = false;
    const keys = Object.keys(payload);
    if (!payload) {
        payload = {};
    }
    keys.forEach((property, index) => {
        if (payload[property] !== undefined && payload[property] !== null && payload[property].name !== undefined && payload[property].lastModified !== undefined && payload[property].size !== undefined) {
            hasFile = true;
        }
    });
    if (hasFile) {
        payload = objectToFormdata(payload);
    }
    if (method.toLowerCase() === 'get' || method.toLowerCase() === 'delete') {
        payload = {
            params: payload,
        };
    }
    return client[method](url, payload)
        .then((response) => Promise.resolve(response))
        .catch((error) => Promise.reject(error));
};
export const identifyApplication = () => {
    const host = window.location.host;
    const application = host.split('.')[0];
    if (application.includes('localhost:') || host.includes(':8080')) {
        if (process.env.VUE_APP_TENANT) {
            return process.env.VUE_APP_TENANT;
        }
        return 'klavertjevier';
    }
    return application;
};
export const isLocal = () => {
    if (!process.env.VUE_APP_API_LOCAL || process.env.VUE_APP_API_LOCAL === 'false') {
        return false;
    }
    const port = window.location.port;
    return !port || port != '80';
};
export const identifyHostname = () => {
    const hostName = trim('.', process.env.VUE_APP_API);
    if (process.env.VUE_APP_HTTP && isLocal()) {
        return `http://${hostName}`;
    }
    if (isLocal()) {
        return `http://${hostName}`;
    }
    return `https://${identifyApplication()}.${hostName}`;
};
export const identifyAppHostname = () => {
    const hostName = trim('.', process.env.VUE_APP_HOSTNAME);
    return `${hostName}`;
};
export const objectToFormdata = (model, form, namespace) => {
    const formData = form || new FormData();
    for (const propertyName in model) {
        if (!model.hasOwnProperty(propertyName) || model[propertyName] == undefined) {
            continue;
        }
        const formKey = namespace ? `${namespace}[${propertyName}]` : propertyName;
        if (model[propertyName] instanceof Date) {
            formData.append(formKey, formatDateTime(model[propertyName]));
        }
        else if (model[propertyName] instanceof Array) {
            model[propertyName].forEach((element, index) => {
                if (typeof element != 'object') {
                    formData.append(`${formKey}[]`, element);
                }
                else {
                    const tempFormKey = `${formKey}[${index}]`;
                    objectToFormdata(element, formData, tempFormKey);
                }
            });
        }
        else if (typeof model[propertyName] === 'object' && !(model[propertyName] instanceof File)) {
            objectToFormdata(model[propertyName], formData, formKey);
        }
        else if (model[propertyName] instanceof File) {
            formData.append(formKey, model[propertyName]);
        }
        else {
            formData.append(formKey, model[propertyName].toString());
        }
    }
    return formData;
};
export const downloadExcel = async (options, payload) => {
    const API = `${identifyHostname()}`;
    const headers = {
        'Content-type': 'application/json',
    };
    headers.Accept = options.accept || 'application/vnd.ms-excel';
    if (Token.get()) {
        headers.Authorization = `Bearer ${Token.get()}`;
    }
    const client = axios.create({
        baseURL: API,
        headers,
        responseType: 'blob',
    });
    await client
        .get(options.url, payload ? { params: payload } : {})
        .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        const disposition = response.request.getResponseHeader(('Content-Disposition').toLowerCase());
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = filenameRegex.exec(disposition);
        let name = '';
        if (matches != null && matches[1]) {
            name = matches[1].replace(/['"]/g, '');
        }
        link.setAttribute('download', name);
        document.body.appendChild(link);
        link.click();
        URL.revokeObjectURL(url);
        link.remove();
    })
        .catch((error) => {
        ErrorHandler.network(error);
    });
};
